import { powerAndStorageRoutes } from '@/routes/sectionRoutes/powerAndStorageRoutes.ts';
import { residentialRoutes } from '@/routes/sectionRoutes/residentialRoutes.ts';
import { commercialAndIndustrialRoutes } from '@/routes/sectionRoutes/commercialAndIndustrialRoutes.ts';
import { networksRoutes } from '@/routes/sectionRoutes/networksRoutes.ts';
import { evsRoutes } from '@/routes/sectionRoutes/evsRoutes.ts';
import { RouteRecordRaw } from 'vue-router';
import { SectionRouteNames } from './sectionRouteNames.ts';
import { flexibilityRoutes } from './flexibilityRoutes.ts';

export const sectionRoutes: Record<SectionRouteNames, RouteRecordRaw> = {
    [SectionRouteNames.powerAndStorage]: {
        path: '/power',
        name: SectionRouteNames.powerAndStorage,
        redirect: { name: powerAndStorageRoutes.home.name },
        meta: {
            headName: 'Power & Storage',
        },
        children: [...Object.values(powerAndStorageRoutes)],
    },
    [SectionRouteNames.networks]: {
        path: '/networks',
        name: SectionRouteNames.networks,
        redirect: { name: networksRoutes.home.name },
        meta: {
            headName: 'Networks',
        },
        children: [...Object.values(networksRoutes)],
    },
    [SectionRouteNames.commercialAndIndustrial]: {
        path: '/commercial-and-industrial',
        name: SectionRouteNames.commercialAndIndustrial,
        redirect: { name: commercialAndIndustrialRoutes.home.name },
        meta: {
            headName: 'C&I',
        },
        children: [...Object.values(commercialAndIndustrialRoutes)],
    },
    [SectionRouteNames.residential]: {
        path: '/residential',
        name: SectionRouteNames.residential,
        redirect: { name: residentialRoutes.home.name },
        meta: {
            headName: 'Residential',
        },
        children: [...Object.values(residentialRoutes)],
    },
    [SectionRouteNames.evs]: {
        path: '/evs',
        name: SectionRouteNames.evs,
        redirect: { name: evsRoutes.home.name },
        meta: {
            headName: 'EV Charging',
        },
        children: [...Object.values(evsRoutes)],
    },
    [SectionRouteNames.flexibility]: {
        path: '/flexibility',
        name: SectionRouteNames.flexibility,
        redirect: { name: flexibilityRoutes.home.name },
        meta: {
            headName: 'Flexibility',
        },
        children: [...Object.values(flexibilityRoutes)],
    },
};
